__turbopack_context__.v({
  "root": "buttonStyles-module__-CYe1W__root",
});
